import styled from 'styled-components';

export const CatcherThrowsFlowWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background-size: 100% 100%;
  position: relative;
  margin-top: 4px;
`;

export const FirstRow = styled.div`
  display: flex;
  margin-top: 19%;
  justify-content: space-around;
  margin-bottom: auto;
  .catcher-throws-option {
    &.position7 {
      margin-top: 7%;
    }
    &.position9 {
      margin-top: 7%;
    }
  }
`;

export const SecondRow = styled.div`
  display: flex;
  margin-top: 7%;
  margin-left: 20%;
  margin-right: 20%;
  justify-content: space-around;
  margin-bottom: auto;
`;

export const ThirdRow = styled.div`
  margin-bottom: auto;
  display: flex;
  margin-left: 5%;
  margin-right: 5%;
  justify-content: space-around;
`;

export const FourthRow = styled.div`
  display: flex;
  margin: 10% auto auto auto;
`;
